<template>
  <Base>
  <template v-slot:toolbar>
    <!-- Masque sur mobile : l'en-tete .wm-head le remplace (titre, compteur,
         recherche, action principale). Deux barres l'une sur l'autre. -->
    <div v-if="!isMobile" id="kt_toolbar" class="toolbar">
      <div id="kt_toolbar_container" class="container-fluid d-flex flex-stack">
        <div class="d-flex align-items-center me-3">
          <slot name="leftToolbar">
            <span class="h-20px border-gray-200 border-start mx-4"></span>
            <ul class="breadcrumb breadcrumb-separatorless fw-bold fs-7 my-1">
              <li class="breadcrumb-item text-muted">
                <router-link :to="{ name: 'dashboard' }" class="text-muted text-hover-primary">
                  <i class="fad fa-home"></i>
                  {{ trans('Survey_list') }}
                </router-link>
              </li>
            </ul>
          </slot>
        </div>


        <div class="d-flex align-items-center py-1">
          <b-dropdown v-if="hasRole('ROLE_MANAGER')" no-caret no-flip right size="sm" tag="div"
            toggle-class="topbar-item text-decoration-none" variant="link">
            <template v-slot:button-content>
              <div class="btn btn-sm btn-clean btn-dropdown btn-primary">
                <i class="fad fa-file-signature fs-2"></i>
                {{ trans('Créer un contrat') }}
              </div>
            </template>
            <b-dropdown-text class="min-w-md-350px p-0" tag="div">
              <Loading v-if="isLoading"></Loading>
              <b-tabs v-else active-nav-item-class="bg-primary text-white" active-tab-class="" fill
                nav-wrapper-class="">
                <b-tab v-for="cat in branchCategories" :key="cat.id" :title="cat.label" :title-link-class="'py-4'">
                  <div class="row g-0 overflow-auto mh-325px">
                    <div v-for="branch in cat.branches" class="col-6">

                      <!--                        <router-link :style="{ '&#45;&#45;bg-hover': branch.color }" :to="{ name: 'contract-creator', params: { branchSlug: branch.slug } }" class="d-flex flex-column flex-center h-100 p-6  border-end border-bottom branch-button">-->
                      <!--                        <span class="svg-icon svg-icon-3x svg-icon-success mb-2">-->
                      <!--                          <i :class="branch.icon + ' fs-3x'" v-if="branch.icon"></i>-->
                      <!--                          <i class="fad fa-question-circle" v-else></i>-->
                      <!--                        </span>-->
                      <!--                          <span class="fs-5 fw-bold text-gray-400 mb-0">-->
                      <!--                          {{ branch.label }}-->
                      <!--                        </span>-->
                      <!--                        </router-link>-->


                      <router-link :style="{ '--bg-hover': branch.color }"
                        :to="{ name: 'avenant-generator', params: { branchSlug: branch.slug, avenantType: 'affaire-nouvelle' } }"
                        class="d-flex flex-column flex-center h-100 p-6  border-end border-bottom branch-button">
                        <span class="svg-icon svg-icon-3x svg-icon-success mb-2">
                          <i v-if="branch.icon" :class="branch.icon + ' fs-3x'"></i>
                          <i v-else class="fad fa-question-circle"></i>
                        </span>
                        <span class="fs-5 fw-bold text-gray-400 mb-0">
                          {{ branch.label }}
                        </span>
                      </router-link>
                    </div>
                  </div>
                </b-tab>
              </b-tabs>
            </b-dropdown-text>
          </b-dropdown>
        </div>
      </div>
    </div>
  </template>
  <template v-slot:content>
    <!-- EN-TETE MOBILE (charte .wm-*) -->
    <div v-if="isMobile" class="wm-head">
      <div class="wm-head-top">
        <div>
          <div class="wm-head-title">Contrats</div>
          <div class="wm-head-sub">{{ matchCount }} correspondance{{ matchCount > 1 ? 's' : '' }}</div>
        </div>
        <div class="wm-head-actions">
          <button class="wm-icon-btn" title="Exporter" @click="requestPrintable()">
            <i class="fad fa-arrow-down-to-line"></i>
          </button>
        </div>
      </div>
      <label class="wm-search">
        <i class="fad fa-magnifying-glass"></i>
        <input v-model="searched.police" type="search"
               placeholder="N&deg; de police, partiel ou complet"
               @keyup.enter="mobileSearch()"/>
      </label>
      <div class="wm-chips">
        <button class="wm-chip wm-chip--filters" @click="filtersOpen = true">
          Filtres
          <span v-if="activeFilterCount > 0" class="wm-chip-count">{{ activeFilterCount }}</span>
        </button>
        <button v-for="chip in mobileChips" :key="'chip_' + chip.key"
                class="wm-chip" :class="{'wm-chip--active': chip.active}"
                @click="filtersOpen = true">
          {{ chip.label }}
          <i class="fad" :class="chip.active ? 'fa-xmark' : 'fa-chevron-down'"></i>
        </button>
      </div>
    </div>

    <!-- La carte de filtres du bureau EST le tiroir sur mobile : un seul balisage,
         deux copies du meme formulaire finiraient par diverger. -->
    <transition name="wm-sheet">
      <div v-if="isMobile && filtersOpen" class="wm-sheet-overlay" @click="filtersOpen = false"></div>
    </transition>

    <div v-show="!isMobile || filtersOpen" :class="isMobile ? 'wm-sheet' : 'card'">
      <div v-if="isMobile" class="wm-sheet-grip"></div>
      <div v-if="isMobile" class="wm-sheet-head">
        <div class="wm-sheet-title">Filtres</div>
        <button class="wm-sheet-reset" @click="resetSearch()">R&eacute;initialiser</button>
      </div>
      <div :class="isMobile ? 'wm-sheet-body' : 'card-body'">
        <div class="row">
          <div v-if="verifyRestrictionSearchToPartner('Branche')" class="col-auto flex-grow-1">
            <label class="mb-2 fw-bolder" for="">{{
              trans("Branche")
            }}</label>
            <b-form-select v-model="searched.branch" class="form-control form-select" @change="updateBranch">
              <b-form-select-option :value="null">{{ trans("Choisir une branche") }}
              </b-form-select-option>
              <template v-for="category in branchCategories">
                <b-form-select-option v-for="(branch, key) in category.branches" :key="branch.uuid"
                  :value="branch.uuid">
                  {{ category.label }} - {{ trans(branch.label) }}
                </b-form-select-option>
              </template>
            </b-form-select>
          </div>

          <div v-if="verifyRestrictionSearchToPartner('Status')" class="col-auto flex-grow-1">
            <label class="mb-2 fw-bolder" for="">{{ trans("Status") }}</label>
            <b-form-select v-model="searched.status" class="form-control form-select">
              <b-form-select-option :value="null">{{ trans("Choisir un status") }}
              </b-form-select-option>
              <template v-for="(status, index) in CONSTANTS.CONTRACT_STATUS">
                <b-form-select-option :key="'status_' + index" :value="status">
                  {{ status }}
                </b-form-select-option>
              </template>
            </b-form-select>
          </div>

          <div v-if="verifyRestrictionSearchToPartner('Assureur')" class="col-auto flex-grow-1">
            <label class="fw-bolder mb-2" for=""> Assureur </label>
            <div>
              <b-form-select v-model="searched.insurer" class="form-control  form-select">
                <b-form-select-option :value="null">{{ trans('Choisir un assureur') }}
                </b-form-select-option>
                <b-form-select-option v-for="insurer in insurers" :key="insurer.uuid" :value="insurer.slug">
                  {{ insurer.label }}
                </b-form-select-option>
              </b-form-select>
            </div>
          </div>
          <div v-if="verifyRestrictionSearchToPartner('Souscripteur')" class="col-auto flex-grow-1">
            <label class="fw-bolder mb-2" for=""> Souscripteur </label>
            <div>
              <input v-model="searched.customer" class="form-control" placeholder="Email,Nom,Prenom,Numero de piece"
                type="text" @keyup.enter="search" />
            </div>
          </div>
        </div>

        <div class="row my-10">
          <div v-if="verifyRestrictionSearchToPartner('Uuid')" class="col-auto flex-grow-1">
            <label class="fw-bolder mb-2" for=""> Uuid / Id </label>
            <div>
              <input v-model="searched.uuid" class="form-control" placeholder="Identifiant" type="text"
                @keyup.enter="search" />
            </div>
          </div>
          <div v-if="verifyRestrictionSearchToPartner('PolicyNumber')" class="col-auto flex-grow-1">
            <label class="fw-bolder mb-2" for=""> Numero de police </label>
            <div>
              <input v-model="searched.police" class="form-control" placeholder="Partiel ou complet" type="text"
                @keyup.enter="search" />
            </div>
          </div>
          <div v-if="hasRole('ROLE_MANAGER')" class="col-auto flex-grow-1">
            <label class="fw-bolder mb-2" for=""> Apporteur </label>
            <div class="d-flex align-items-center">
              <div class="flex-grow-1">
                <input v-model="searched.partner" class="form-control" placeholder="Apporteur" type="text"
                  @keyup.enter="search" />
              </div>
            </div>
          </div>
          <div v-if="hasRole('ROLE_MANAGER')" class="col-auto flex-grow-1">
            <label class="fw-bolder mb-2" for=""> Gestionnaire </label>
            <div class="d-flex align-items-center">
              <div class="flex-grow-1">
                <input v-model="searched.manager" class="form-control" placeholder="Gestionnaire" type="text"
                  @keyup.enter="search" />
              </div>
            </div>
          </div>
        </div>

        <div class="row my-10">
          <div v-if="verifyRestrictionSearchToPartner('effectiveDate')" class="col-auto flex-grow-1">
            <label class="fw-bolder mb-2" for="">
              Date d'effet entre :
            </label>
            <div class="d-flex align-items-center">
              <div class="flex-grow-1">
                <input v-model="searched.effetMin" class="form-control" type="date" />
              </div>
              <div class="mx-3 fw-bolder">et</div>
              <div class="flex-grow-1">
                <input v-model="searched.effetMax" class="form-control" type="date" />
              </div>
            </div>
          </div>

          <div v-if="verifyRestrictionSearchToPartner('endDate')"
            class="col-auto flex-grow-1 border-start border-2 border-start-dashed">
            <label class="fw-bolder mb-2" for=""> Expire entre : </label>
            <div class="d-flex align-items-center">
              <div class="flex-grow-1">
                <input v-model="searched.expireMin" class="form-control" type="date" />
              </div>
              <div class="mx-3 fw-bolder">et</div>
              <div class="flex-grow-1">
                <input v-model="searched.expireMax" class="form-control" type="date" />
              </div>
            </div>
          </div>

          <div v-if="verifyRestrictionSearchToPartner('createdDate')"
            class="col-auto flex-grow-1 border-start border-2 border-start-dashed">
            <label class="fw-bolder mb-2" for=""> Créer entre : </label>
            <div class="d-flex align-items-center">
              <div class="flex-grow-1">
                <input v-model="searched.createMin" class="form-control" type="date" />
              </div>
              <div class="mx-3 fw-bolder">et</div>
              <div class="flex-grow-1">
                <input v-model="searched.createMax" class="form-control" type="date" />
              </div>
            </div>
          </div>
        </div>
        <!--          <div class="d-flex justify-content-center">-->
        <!--            <div @click="resetSearch" class="btn btn-danger me-5 d-flex align-items-center">-->
        <!--              <i class="fad fa-trash"></i>-->
        <!--              Réinitialiser-->
        <!--            </div>-->
        <!--            <button :disabled="searching" @click="search" class="btn btn-primary d-flex align-items-center">-->
        <!--              <i class="fad fa-search"></i>-->
        <!--              Rechercher-->
        <!--            </button>-->
        <!--          </div>-->

        <!--          <div class="fs-2 fw-bolder mb-2 cursor-pointer text-hover-primary" @click="advancedSearch = !advancedSearch">-->
        <!--            <i class="fad fa-caret-right me-2 fs-2" v-if="!advancedSearch"></i>-->
        <!--            <i class="fad fa-caret-down me-2 fs-2" v-else></i>-->
        <!--            Recherche avancée-->
        <!--          </div>-->
        <div>
          <div class="row my-10">
            <div v-if="verifyRestrictionSearchToPartner('Objet')" class="col-auto flex-grow-1">
              <label class="mb-2 fw-bolder" for="">{{
                trans("Objet")
              }}</label>
              <b-form-select v-model="searched.itemType" class="form-control form-select">
                <template v-if="searched.branch">
                  <b-form-select-option :value="null">{{ trans("Choisir un objet") }}
                  </b-form-select-option>
                  <template v-for="itemType in itemTypes">
                    <template v-if="itemType.branch.uuid === searched.branch">
                      <b-form-select-option :key="itemType.uuid" :value="itemType.uuid">
                        {{ itemType.name }}
                      </b-form-select-option>
                    </template>
                  </template>
                </template>
                <b-form-select-option v-else :value="null">{{
                  trans("Choisir une branche")
                }}
                </b-form-select-option>
              </b-form-select>
            </div>

            <div v-if="verifyRestrictionSearchToPartner('Propriété')" class="col-auto flex-grow-1">
              <label class="mb-2 fw-bolder" for="">{{
                trans("Propriété")
              }}</label>
              <b-form-select v-model="searched.itemProperty" class="form-control form-select">
                <template v-if="searched.itemType">
                  <b-form-select-option :value="null">{{
                    trans("Choisir une propriété")
                  }}
                  </b-form-select-option>
                  <template v-for="itemType in itemTypes">
                    <template v-if="itemType.uuid === searched.itemType">
                      <b-form-select-option v-for="property in itemType.properties" :key="property.uuid"
                        :value="property.uuid">
                        {{ property.name }}
                      </b-form-select-option>
                    </template>
                  </template>
                </template>
                <b-form-select-option v-else :value="null">{{ trans("Choisir un objet") }}
                </b-form-select-option>
              </b-form-select>
            </div>

            <div v-if="verifyRestrictionSearchToPartner('Valeur')" class="col-auto flex-grow-1">
              <label class="mb-2 fw-bolder" for="">{{
                trans("Valeur")
              }}</label>
              <input v-model="searched.propertyValue" class="form-control" type="text" @keyup.enter="search" />
            </div>

            <div v-if="hasRole('ROLE_ADMIN')" class="col-auto flex-grow-1">
              <label class="mb-2 fw-bolder" for="">{{
                trans("Chercher parmis les contrats supprimés")
              }}</label>
              <BooleanInput v-model="searched.deleted" />
            </div>
          </div>

          <div class="d-flex justify-content-center">
            <div class="btn btn-danger me-5 d-flex align-items-center" @click="resetSearch">
              <i class="fad fa-trash"></i>
              Réinitialiser
            </div>
            <button :disabled="searching" class="btn btn-primary d-flex align-items-center" @click="search">
              <i class="fad fa-search"></i>
              Rechercher
            </button>
          </div>
        </div>
      </div>
      <div v-if="isMobile" class="wm-sheet-actions">
        <button class="wm-btn wm-btn--ghost" @click="filtersOpen = false">Annuler</button>
        <button class="wm-btn wm-btn--primary" :disabled="searching" @click="mobileSearch()">
          Rechercher<template v-if="matchCount"> ({{ matchCount }})</template>
        </button>
      </div>
    </div>

    <div v-if="!isMobile" class="fs-2x fw-bolder mt-10 d-flex justify-content-between align-items-center">
      <div>
        {{ matchCount }}
        <template v-if="matchCount > 1">Correspondances</template>
        <template v-else>Correspondance</template>
      </div>

      <div v-if="selected.length > 0" class="d-flex align-items-center">
        {{ selected.length }}
        <template v-if="selected.length <= 1">selectionné</template>
        <template v-else>selectionnés</template>
        <div class="btn btn-danger btn-icon ms-5" @click="deleteContracts(null)">
          <i class="fad fa-trash"></i>
        </div>
      </div>
    </div>
    <div v-if="!isMobile" class="card mt-10">
      <div class="card-body">
        <div v-if="contracts.length > 0" class="d-flex justify-content-end">
          <button class="btn btn-primary d-flex align-items-center mb-3" @click="requestPrintable()">
            <span class="me-3">Exporter</span> <i class="fad fa-print"></i>
          </button>
        </div>

        <div class="flex-1 overflow-auto">
        <table class="table table-striped gy-3 gs-3">
          <thead>
            <tr class="fw-bolder fs-6 text-gray-800 border-bottom border-gray-200">
              <th v-if="verifyRestrictionListToPartner('Police')">
                <div class="d-flex align-items-center gap-5">
                <label class="form-check form-check-sm form-check-custom form-check-solid" @click="toggleSelectAll">
                  <input :checked="selected.length > 0" class="form-check-input" data-kt-check="true"
                         data-kt-check-target=".widget-9-check" type="checkbox" value="1" />
                </label>
                {{ trans("Police") }}
                </div>
              </th>
              <th v-if="verifyRestrictionListToPartner('Actif')">Actifs</th>
              <th v-if="verifyRestrictionListToPartner('Souscripteur')">Souscripteur</th>
              <th v-if="verifyRestrictionListToPartner('Emission')">Emission</th>
              <th v-if="verifyRestrictionListToPartner('Durée')">Durée</th>
              <th v-if="verifyRestrictionListToPartner('Status/Gestionnaire')" class="text-center">
                {{trans("Status/Gestionnaire") }}
              </th>
              <th v-if="verifyRestrictionListToPartner('Apporteur')">{{ trans("Apporteur") }}</th>
              <th v-if="verifyRestrictionListToPartner('Prime TTC')">{{ trans("Prime TTC") }}</th>
              <th  v-if="verifyRestrictionListToPartner('Actions')">{{ trans("Actions") }}</th>
            </tr>
          </thead>
          <tbody>
            <tr v-if="searching">
              <td colspan="10">
                <Loading></Loading>
              </td>
            </tr>
            <tr v-else-if="contracts.length === 0">
              <td colspan="10">
                <div class="d-flex flex-column flex-grow-1 align-items-center justify-content-center p-20">
                  <i class="fad fa-empty-set fs-5x"></i>
                  <span class="fs-2 text-gray-400">
                    {{trans("Aucun resultat") }}
                  </span>
                </div>
              </td>
            </tr>
            <template v-for="contract in contracts" v-else>
              <tr v-if="!searched.branch || searched.branch === contract.branch.uuid" :class="{ 'bg-light-danger': !!contract.deletedAt }">
                <td  class="position-relative" v-if="verifyRestrictionListToPartner('Police')">
                  <div class="d-flex align-items-center gap-5">
                  <RowSelector v-model="selected" :data="contract.uuid" />
<!--                  <i class="fad fa-exclamation-triangle text-danger position-absolute" style="left: -10px"></i>-->
                  <div>
                    <div class="text-primary fw-bolder d-flex align-items-center fs-7 text-uppercase">
                      <i :class="'fad fs-2 ' + contract.branch.icon" class="me-2 text-inherit"></i>
                      {{ contract.branch.category.label }}  ▪  {{ contract.branch.label }}
                    </div>
                    <div class="d-flex align-items-center fw-bolder">
                      {{ contract.insurer.label }} ❖ {{ contract.police }}
                    </div>
                    <div class="me-2">
                      {{ readableDate(contract.createdAt, "dMy H:i") }}
                    </div>
                  </div>
                  </div>
                </td>
                <td v-if="verifyRestrictionListToPartner('Actif')">
                  <div class="fw-bolder" v-if="contract.alias && contract.alias.trim()">
                    {{ contract.alias }}
                  </div>
                  <div class="fw-bolder" v-else-if="assetsMap[contract.uuid] && assetsMap[contract.uuid].identifiers && assetsMap[contract.uuid].identifiers.length > 0">
                    {{ assetsMap[contract.uuid].identifiers[0] }}
                  </div>
                  <div v-if="assetsMap[contract.uuid] && assetsMap[contract.uuid].labels && assetsMap[contract.uuid].labels.length > 0">
                    <span v-for="(label, idx) in assetsMap[contract.uuid].labels" :key="'asset_'+contract.uuid+'_'+idx" class="badge badge-secondary me-1 mb-1">
                      {{ label }}
                    </span>
                    <span v-if="assetsMap[contract.uuid].total > assetsMap[contract.uuid].labels.length"
                          class="badge badge-light-primary cursor-pointer"
                          @click="showAllAssets(contract)">
                      + {{ assetsMap[contract.uuid].total - assetsMap[contract.uuid].labels.length }} autres
                    </span>
                  </div>
                  <div v-if="(!contract.alias || !contract.alias.trim()) && (!assetsMap[contract.uuid] || assetsMap[contract.uuid].total === 0)" class="text-muted fs-8">
                    -
                  </div>
                </td>

                <td v-if="verifyRestrictionListToPartner('Souscripteur')">
                  {{ contract.subscriber.name }}
                  {{ contract.subscriber.prename }}
                  <br />
                  <span class="text-gray-400 fw-bolder">
                    {{ contract.subscriber.email }}
                  </span>
                  <br />
                  <user-view v-model="contract.source"></user-view>
                </td>
                <td v-if="verifyRestrictionListToPartner('Emission')">
                  <template v-if="contract.dateEmission">
                    {{ readableDate(contract.dateEmission, "dMY H:i") }}
                    <br />
                    <span class="fw-bolder">
                      <user-view v-model="contract.emitBy"></user-view>
                    </span>
                  </template>
                  <div v-else>
                    <span>
                      <i class="fad fa-empty-set fs-2"></i>
                    </span>
                  </div>
                  <!-- <user-view v-model="contract.emitBy"/> -->
                </td>
                <td v-if="verifyRestrictionListToPartner('Durée')">
                  <div class="fw-bolder align-items-center">
                    <div v-if="contract.startAt" v-b-tooltip.hover :title="readableDate(contract.startAt, 'dmY')">
                      {{ readableDate(contract.startAt, "dMY") }}
                    </div>
                    <div v-if="contract.expireAt" v-b-tooltip.hover :title="readableDate(contract.expireAt, 'dmY')">
                      {{ readableDate(contract.expireAt, "dMY") }}
                    </div>
                  </div>
                </td>
                <td v-if="verifyRestrictionListToPartner('Status/Gestionnaire')">
                  <div class="d-flex flex-column justify-content-center align-items-center">
                    <div>
                      <span :class="{
                        'badge-primary':
                          contract.status ===
                          CONSTANTS.CONTRACT_STATUS.PAUSED ||
                          contract.status ===
                          CONSTANTS.CONTRACT_STATUS.WAITING,
                        'badge-warning':
                          contract.status ===
                          CONSTANTS.CONTRACT_STATUS.QUOTATION,
                        'badge-success':
                          contract.status ===
                          CONSTANTS.CONTRACT_STATUS.ONGOING,
                        'badge-danger':
                          contract.status === CONSTANTS.CONTRACT_STATUS.EXPIRED ||
                          contract.status === CONSTANTS.CONTRACT_STATUS.CANCELLED,
                        'badge-dark':
                          contract.status ===
                          CONSTANTS.CONTRACT_STATUS.RENEW,
                      }" class="badge">
                        {{ contract.status }}
                      </span>
                    </div>
                    <div class="fw-bolder mt-1">
                      <user-view v-model="contract.manager"></user-view>
                    </div>
                  </div>
                </td>
                <td v-if="verifyRestrictionListToPartner('Apporteur')">
                  <div class="mw-200px">
                    <template v-if="contract.partner">
                      <div class="fw-bolder">
                        {{ contract.partner.name }}
                      </div>
                      <div class="text-gray-400 fw-bolder fs-8">
                        {{ contract.partner.code }}
                      </div>
                    </template>
                  </div>
                </td>
                <td v-if="verifyRestrictionListToPartner('Prime TTC')">
                  <span class="fw-bolder">
                    {{ currency(contract.primeTTC) }}
                  </span>
                  <br />
                  <span class="text-danger fw-bolder">
                    {{ currency(contract.balance, true) }}
                  </span>
                </td>
                <td  class="text-end" v-if="verifyRestrictionListToPartner('Actions')">
                  <router-link :to="{
                    name: 'contract-show',
                    params: { contractUuid: contract.uuid },
                  }" class="btn btn-xs btn-icon btn-primary">
                    <i class="fad fa-eye"></i>
                  </router-link>

                  <div v-if="hasRole('ROLE_ADMIN')" class="btn btn-xs btn-icon btn-danger ms-3"
                    @click="deleteContracts(contract.uuid)">
                    <i class="fad fa-trash"></i>
                  </div>
                </td>
              </tr>
            </template>
          </tbody>
        </table>
        </div>
      </div>
    </div>

    <!-- LISTE MOBILE : une carte par contrat. Le tableau du bureau compte neuf
         colonnes, il ne se lit pas sur un telephone -- on garde ce qui identifie
         (police, statut, souscripteur, objet) et ce qui decide (periode, prime). -->
    <div v-if="isMobile" class="wm-screen">
      <div class="wm-meta">
        <span class="wm-meta-count">{{ contracts.length }} sur {{ matchCount }}</span>
        <span class="wm-meta-action" @click="filtersOpen = true">Filtrer</span>
      </div>
      <div class="wm-list">
        <div v-if="contracts.length === 0" class="wm-empty" style="margin:14px">
          Aucun contrat ne correspond
        </div>
        <div v-for="contract in contracts" :key="'mc_' + contract.uuid" class="wm-row">
          <div class="wm-row-top">
            <span class="wm-row-title wm-mono">{{ contract.police || '-' }}</span>
            <span class="wm-badge" :class="contractBadgeClass(contract)">{{ contract.status }}</span>
          </div>
          <div class="wm-row-sub">
            {{ contract.insurer ? contract.insurer.label : '-' }}
            <template v-if="contract.branch">
              &middot; {{ contract.branch.category ? contract.branch.category.label : '' }}
              &middot; {{ contract.branch.label }}
            </template>
          </div>
          <div class="wm-row-title" style="margin-top:7px">
            {{ contractSubscriber(contract) }}
          </div>
          <div v-if="contractAsset(contract)" class="wm-row-line">
            <span class="wm-tag wm-mono">{{ contractAsset(contract) }}</span>
            <span class="wm-row-sub" style="margin-top:0;overflow:hidden;text-overflow:ellipsis;white-space:nowrap">
              {{ contractAssetLabel(contract) }}
            </span>
          </div>
          <div class="wm-row-foot">
            <div>
              <div class="wm-caption">Effet &rarr; Expiration</div>
              <div class="wm-mono wm-row-sub" style="margin-top:2px;color:var(--wm-ink-2)">
                {{ readableDate(contract.startAt, 'dMY') }} &rarr; {{ readableDate(contract.expireAt, 'dMY') }}
              </div>
            </div>
            <div style="text-align:right">
              <div class="wm-amount">{{ currency(contract.primeTTC) }}</div>
              <div v-if="contract.balance" class="wm-mono" style="font-size:11px;color:var(--wm-danger);margin-top:1px">
                Reste {{ currency(contract.balance, true) }}
              </div>
            </div>
          </div>

          <!-- Les actions de la ligne du bureau. En router-link et non en @click :
               on doit pouvoir ouvrir la fiche dans un nouvel onglet. -->
          <div class="wm-row-actions">
            <router-link :to="{name: 'contract-show', params: {contractUuid: contract.uuid}}"
                         class="wm-act wm-act--primary" :title="trans('Voir le contrat')">
              <i class="fad fa-eye"></i>
            </router-link>
            <button v-if="hasRole('ROLE_ADMIN')" class="wm-act wm-act--danger"
                    :title="trans('Supprimer')" @click="deleteContracts(contract.uuid)">
              <i class="fad fa-trash"></i>
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Meme composant des deux cotes : il sait se rendre en mobile. -->
    <div :class="isMobile ? '' : 'my-20'">
      <Pagination v-model="searched.page" :count="total" :itemLength="contracts.length" :matchCount="matchCount"
        :perPage="searched.perPage" :showEmpty="true" @input="search"></Pagination>
    </div>
  </template>
  </Base>
</template>
<script lang="ts">
import { Component, Vue } from "vue-property-decorator";
import Base from "@/layouts/Base.vue";
import BranchCategory from "@/entity/BranchCategory";
import Loading from "@/components/Loading.vue";
import { api } from "@/services/Api";
import Pagination from "@/components/Pagination.vue";
import UserView from "@/components/UserView.vue";
import Contract from "@/entity/Contract";
import Swal from "sweetalert2";
import User from "@/entity/User";
import Partner from "@/entity/Partner";
import Popup from "@/entity/Popup";
import Insurer from "@/entity/Insurer";
import RowSelector from "@/components/RowSelector.vue";
import { helper } from "@/services/Helper";
import DateRangePicker from "vue2-daterange-picker";
import BooleanInput from "@/components/BooleanInput.vue";
import { auth } from "@/services/Auth";
import MobileAware from "@/mixins/MobileAware";
import CONSTANTS from "@/Utils/constant";

@Component({
  // `mixins` en OPTION et non `extends mixins(...)` : l'helper de
  // vue-property-decorator fait perdre le typage de Vue a la classe
  // ($store, $route... deviennent inconnus de TypeScript).
  mixins: [MobileAware],
  methods: {},
  components: {
    BooleanInput,
    RowSelector,
    Pagination,
    Loading,
    Base,
    UserView,
    DateRangePicker,
  },
})
export default class ContractList extends Vue {
  // Fourni par le mixin MobileAware (declaration de type seulement).
  isMobile!: boolean;
  total = 0;
  // Tiroir de filtres (mobile). Sur le bureau la meme carte reste affichee en
  // permanence : c'est le meme balisage, pas une copie.
  filtersOpen = false;
  selected: any[] = [];
  matchCount = 0;
  uploadRoot = api.uploadRoot;
  branchCategories: BranchCategory[] = [];
  itemTypes: any[] = [];
  searching = false;
  advancedSearch = false;
  assetsMap: any = {};
  searched: any = {
    branch: null,
    customer: null,
    insurer: null,
    partner: null,
    manager: null,
    uuid: null,
    police: null,
    status: null,
    effetMin: null,
    effetMax: null,
    expireMin: null,
    expireMax: null,
    createMin: null,
    createMax: null,
    itemType: null,
    itemProperty: null,
    propertyValue: null,
    deleted: false,
    page: 1,
    perPage: 10
  }
  contracts: any[] = []
  printRequest: any = null;
  lastId = 0;
  settings: any = null;
  isLoading = false;
  partners: Partner[] = [];
  managers: User[] = [];
  insurers: Insurer[] = [];

  // async printContracts() {
  //   if (helper.empty(this.printRequest)) {
  //     this.printRequest = helper.generateId()
  //   }
  //   this.$store.commit('loading')
  //   const res = await api.post(api.core, 'contracts/receipts', {
  //     searched: this.searched,
  //     printRequest: this.printRequest
  //   }, {
  //     responseType: "blob",
  //   })
  //   const blob = new Blob([res.data], {type: res.headers['content-type'] as any});
  //   let url = window.URL || window.webkitURL;
  //   let link = url.createObjectURL(blob);
  //   let a = document.createElement("a");
  //   var title = 'contrats'
  //         a.setAttribute("download", 'Liste des ' + helper.slugify(title));
  //   a.setAttribute("href", link);
  //   document.body.appendChild(a);
  //   a.click();
  //   document.body.removeChild(a);
  //   this.$store.commit('stopLoading')

  // }

  toggleSelectAll() {
    if (helper.empty(this.selected)) {
      this.contracts.forEach((c: Contract) => {
        if (!this.selected.includes(c.uuid)) {
          this.selected.push(c.uuid);
        }
      });
    } else {
      this.selected = [];
    }
  }

  updateBranch() {
    this.searched.itemType = null;
    this.searched.itemProperty = null;
  }

  /**
   * Couleur du statut. Les memes correspondances que le tableau du bureau, mais
   * exprimees en classes de la charte : une couleur ecrite en dur dans une page
   * est une couleur qui ne bougera pas le jour ou la charte change.
   */
  contractBadgeClass(contract: any): string {
    const s = contract && contract.status;
    if (s === CONSTANTS.CONTRACT_STATUS.ONGOING) return "wm-badge--success";
    if (s === CONSTANTS.CONTRACT_STATUS.EXPIRED || s === CONSTANTS.CONTRACT_STATUS.CANCELLED) return "wm-badge--danger";
    if (s === CONSTANTS.CONTRACT_STATUS.QUOTATION) return "wm-badge--warning";
    if (s === CONSTANTS.CONTRACT_STATUS.PAUSED || s === CONSTANTS.CONTRACT_STATUS.WAITING) return "wm-badge--muted";
    return "";
  }

  contractSubscriber(contract: any): string {
    const sub = contract && contract.subscriber;
    if (!sub) return "-";
    return [sub.name, sub.prename].filter((x: any) => !!x).join(" ") || "-";
  }

  /** Immatriculation ou identifiant de l'objet assure. */
  contractAsset(contract: any): string {
    if (contract && contract.alias && contract.alias.trim()) return contract.alias.trim();
    const map = this.assetsMap[contract.uuid];
    if (map && map.identifiers && map.identifiers.length > 0) return map.identifiers[0];
    return "";
  }

  /** Libelles des objets assures, joints. Vide si le contrat n'en porte pas. */
  contractAssetLabel(contract: any): string {
    const map = this.assetsMap[contract.uuid];
    if (!map || !map.labels || map.labels.length === 0) return "";
    const shown = map.labels.join(", ");
    const rest = (map.total || 0) - map.labels.length;
    return rest > 0 ? shown + " +" + rest : shown;
  }

  /**
   * Filtres reellement POSES, pour le compteur de la puce. Sans lui, on ne sait
   * pas ce qui restreint la liste qu'on regarde.
   */
  get activeFilterCount(): number {
    const ignored = ["page", "perPage", "deleted"];
    return Object.keys(this.searched).filter((k: string) => {
      if (ignored.indexOf(k) !== -1) return false;
      const v = this.searched[k];
      return v !== null && v !== undefined && v !== "" && v !== false;
    }).length;
  }

  /** Puces de l'en-tete mobile : les filtres les plus utilises, etat compris. */
  get mobileChips(): any[] {
    return [
      {key: "branch", label: "Branche", active: !!this.searched.branch},
      {key: "insurer", label: "Assureur", active: !!this.searched.insurer},
      {key: "status", label: "Status", active: !!this.searched.status},
      {key: "effet", label: "Date d'effet", active: !!this.searched.effetMin || !!this.searched.effetMax},
      {key: "itemProperty", label: "Objet", active: !!this.searched.itemProperty},
    ];
  }

  /** Rechercher depuis le mobile referme le tiroir : le resultat est derriere. */
  mobileSearch() {
    this.searched.page = 1;
    this.filtersOpen = false;
    this.search();
  }

  resetSearch() {
    const keys = Object.keys(this.searched);
    keys.forEach((k: any) => {
      this.searched[k] = null;
    });
    this.searched.page = 1;
    this.searched.perPage = 50;
  }

  async requestPrintable() {
    this.printRequest = helper.generateId();
    this.lastId = 0;

    if (auth.hasRole("ROLE_ADMIN-PARTNER") && !auth.hasRole("ROLE_ADMIN")) {
      this.preparePrintable("ROLE_ADMIN-PARTNER");
    } else {
      this.preparePrintable();
    }
  }

  async preparePrintable(
    role = null,
    page = this.searched.page,
    download = false
  ) {
    const maxPage =
      this.matchCount > 0
        ? Math.ceil(this.matchCount / this.searched.perPage)
        : 1;
    this.$store.commit("loading");
    let message =
      '<div class="fw-bolder my-5 fs-2">Exportation de la page ' +
      page +
      "/ " +
      maxPage +
      "</div>";

    if (page > maxPage) {
      message =
        '<div class="fw-bolder my-5 fs-2">Téléchargement du fichier en cours ...</div>';
      download = true;
    }

    this.$store.commit("loading", message);

    const res = await api.post(
      api.core,
      role == "ROLE_ADMIN-PARTNER"
        ? "avenant/list/print"
        : "contract/list/print",
      {
        searched: this.searched,
        printRequest: this.printRequest,
        lastId: this.lastId,
      }
    );
    if (res && res.data) {
      if (download === true) {
        const res = await api.post(
          api.core,
          "contract/download/printable",
          {
            searched: this.searched,
            printRequest: this.printRequest,
          },
          {
            responseType: "blob",
          }
        );
        if (res) {
          const blob = new Blob([res.data], {
            type: res.headers["content-type"] as any,
          });
          let url = window.URL || window.webkitURL;
          let link = url.createObjectURL(blob);
          let a = document.createElement("a");
          var title = "contrats";
          a.setAttribute("download", "Liste des " + helper.slugify(title));
          a.setAttribute("href", link);
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
        }
        this.$store.commit("stopLoading");
      } else {
        this.searched.page++;
        await this.preparePrintable();
      }
    } else {
      this.$store.commit("stopLoading");
    }
  }

  async deleteContracts(uuid: any = null) {
    if (!helper.empty(uuid)) {
      this.selected = [uuid];
    }
    if (this.selected.length === 0) {
      return;
    }
    const response = await Swal.fire({
      title: "Supprimer",
      html:
        "Êtes-vous sûr de vouloir supprimer ces " +
        this.selected.length +
        " contrats ?",
      timer: 10000,
      timerProgressBar: true,
      showCancelButton: true,
      confirmButtonText: "Supprimer",
      didOpen: () => {
        // Swal.showLoading()
        // const b = Swal.getHtmlContainer().querySelector('b')
        // timerInterval = setInterval(() => {
        //     b.textContent = Swal.getTimerLeft()
        // }, 100)
      },
      willClose: () => {
        // clearInterval(timerInterval)
      },
    });
    if (response.isConfirmed) {
      this.$store.commit("loading");
      const res = await api.post(api.core, "contract/delete", {
        uuids: this.selected,
      });
      if (res) {
        this.selected = [];
        this.search();
      }
      this.$store.commit("stopLoading");
    }
  }

  showAllAssets(contract: any) {
    this.$router.push({name: 'contract-show', params: {contractUuid: contract.uuid}})
  }

  async search() {
    if (this.searching) {
      return;
    }
    this.searching = true;
    const res = await api.post(api.core, "contract/search", {
      searched: this.searched,
    });
    if (res && res.data && res.data.contracts) {
      this.contracts = [];
      res.data.contracts.forEach((c: Contract) => {
        const occ = new Contract(c);
        this.contracts.push(occ);
      });
      this.total = res.data.total;
      this.matchCount = res.data.matchCount;
      if (res.data.assets) {
        this.assetsMap = res.data.assets;
      }
    }
    this.searching = false;
  }

  async mounted() {
    this.$store.commit("loading");
    await this.loadData();
    this.$store.commit("stopLoading");
    this.settings = this.$store.state.settings;
  }

  verifyRestrictionSearchToPartner(key: any): boolean {
    if (!this.settings || this.settings === null) {
      return true;
    }

    if (
      !this.settings.searchKeyContract ||
      this.settings.searchKeyContract.length === 0
    ) {
      return true;
    }

    return this.settings.searchKeyContract.includes(key);
  }

  verifyRestrictionListToPartner(key: any): boolean {
    if (!this.settings || this.settings === null) {
      return true;
    }

    if (
      !this.settings.listKeyContract ||
      this.settings.listKeyContract.length === 0
    ) {
      return true;
    }

    return this.settings.listKeyContract.includes(key);
  }

  async loadData() {
    const res = await api.get(api.core, "contract/list/requirements");
    if (res && res.data) {
      this.partners = [];
      res.data.partners?.forEach((p: Partner) => {
        this.partners.push(new Partner(p));
      });
      this.insurers = [];
      res.data.insurers?.forEach((i: Insurer) => {
        this.insurers.push(new Insurer(i));
      });
      this.branchCategories = [];
      res.data.categories?.forEach((i: Insurer) => {
        this.branchCategories.push(new BranchCategory(i));
      });
      this.itemTypes = res.data.itemTypes;
    }
  }

  async loadBranches() {
    this.isLoading = true;
    this.branchCategories = await this.$store.getters.branchCategories();
    this.isLoading = false;
  }

  async loadPartners() {
    return
    const res = await api.get(api.core, "partner/list");
    if (res && res.data) {
      this.partners = [];
      res.data.partners.forEach((p: Partner) => {
        this.partners.push(new Partner(p));
      });
    }
  }

  async loadManagers() {
    this.managers = await api.loadManagers();
  }

  async loadInsurers() {
    const popup = new Popup(
      "Chargement des assureurs",
      "",
      "warning",
      "fad fa-cogs",
      true
    );
    const res = await api.get(api.core, "insurer/list");
    if (res && res.data && res.data.insurers) {
      this.insurers = [];
      res.data.insurers.forEach((i: Insurer) => {
        this.insurers.push(new Insurer(i));
      });
    }
    popup.hide();
  }
}
</script>
<style scoped>
.bg-light-danger {
  background-color: #FFF5F8 !important;
  --bs-table-accent-bg: transparent !important;

}

td{
  background-color: inherit!important;
}
.table > :not(caption) > * > .sticky {
  position: sticky;
  background-color: inherit;
  z-index: 2;
  background-clip: padding-box;
}

/* lignes impaires */
.table-striped > tbody > tr:nth-of-type(odd) > .sticky {
  background-color: var(--bs-table-striped-bg);
}

/* hover */
.table-hover > tbody > tr:hover > .sticky {
  background-color: var(--bs-table-hover-bg);
}

/* active */
.table > tbody > tr.table-active > .sticky {
  background-color: var(--bs-table-active-bg);
}

.p-0 .b-dropdown-text {
  padding: 0;
}

.sticky-option {
  position: sticky;
  right: 0;
  background-color: #fff;
}
td{
  white-space: nowrap;
}
</style>
